/**
 * Shared typography and spacing constants for all accounting pages.
 * Import these instead of hardcoding font sizes.
 */

export const fontSize = {
  xs: '0.75rem',    // 12px — labels, secondary text, chips
  sm: '0.875rem',   // 14px — body text, table cells
  md: '1rem',       // 16px — page titles, card headers
  lg: '1.25rem',    // 20px — KPI values
  xl: '1.5rem',     // 24px — hero numbers (dashboard)
};

export const fontWeight = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};
